import {
  Container,
  Box,
  Autocomplete,
  TextField,
  Divider,
  Chip,
  Typography,
  RadioGroup,
  Checkbox,
  Stack,
  Alert,
  AlertTitle,
} from "@mui/material";

import Radio from "../components/Base/Radio/index";
import Input from "../components/Base/Input";
import React, { useEffect, useRef, useState } from "react";
import Header from "../components/common/Header";
import IntroCard from "../components/Cards/IntroCard";
import SubmitButton from "../components/common/SubmitButton";
import Note from "../components/common/Note";
import configData from "../Config";
import { useNavigate, useLocation } from "react-router-dom";
import Backdrop from "../components/common/Backdrop";
import LoadingDots from "../components/Lottie/LoadingDots";
import { apis } from "../services/apiService";
import RadioLink from "../components/common/RadioLink";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import styles from "../Style/Modules/bankStatement.module.css";
import "../Style/Theme/index.css";
import { VerifyMobile, loggerStore } from "../utils/utils";
import AlertPopup from "../components/common/AlertPopup";
import { CONSTANTS } from "../utils/constant";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const BANKSELECT = "bankSelect";
const BANKSTATEMENTUPLOAD = "bankStatementUpload";
const CHECKCONSENTSTATUS = ["INITIATED", "PROCESSING", "COMPLETED"];
const CHECKBSTRSP = ["PENDING", "IN_PROGRESS"]
export default function BankStatement() {
  let initialdata = {
    phoneNumber: "",
    zipPassword: "",
    pdfPassword: "",
  };
  const navigate = useNavigate();
  let location = useLocation();
  const [mobileErr, setMobileErr] = useState("");
  const [bankStmtEmsg, setBankStmtEmsg] = useState("");
  const [docUploadEMsg, setDocUploadEMsg] = useState();
  const [disabled, setDisabled] = useState(true);
  const [inputFileDisable, setInputFileDisable] = useState(true);
  const [inputMnoDisable, setInputMnoDisable] = useState(true);
  const [files, setFiles] = useState();
  const [loading, setLoading] = useState(false);
  const [bankName, setBankName] = useState([]);
  const [bankNameList, setBankNameList] = useState([]);
  const [radioVal, setRadioVal] = useState(null);
  const [zipExtensionHide, setZipExtensionHide] = useState(true);
  const [pdfExtensionHide, setPdfExtensionHide] = useState(true);
  const [retryDocUploadStatus, setRetryDocUploadStatus] = useState(false);
  const [finalErr, setFinalErr] = useState("");
  const [formData, setFormData] = useState(initialdata);
  let errors_Old = {
    1: "Enter valid mobile number.",
    2: "Please select bank Name",
  };

  let errors = {
    1: "Enter valid mobile number",
    2: "Please select bank Name",
    3: "Mobile number should not start with 0",
  };

  const bankNameRef = useRef([]);

  const handleOnChange = (e) => {
    setFormData({ ...formData, [e?.target?.name]: e?.target?.value });
    if (e?.target?.name === "phoneNumber") {
      if (e?.target?.value && !VerifyMobile(e?.target?.value)) {
        parseInt(e?.target?.value.charAt(0)) === 0
          ? setMobileErr(errors[3])
          : setMobileErr(errors[1]);
      } else {
        setMobileErr("");
      }
    }
  };

  const checkMobileStHandler = (data) => {
    const reqData = {
      aid: location.state.AppId,
      panNumber: "",
      trackingId: data.trackingId,
      referenceId: data.referenceId,
    };
    apis
      .postApi(configData.API_URL + "BRE/MobileBankst", reqData)
      .then((response) => {
        setLoading(false);
        const reqData = { AppId: location.state.AppId };
        navigate("/loading", { state: reqData });
      });
  };

  const handleSetInterval = async (data) => {
    let timer = CONSTANTS.bankStatementInterval.TIMERINITIAL;
    const apiCheck = setInterval(async () => {
      if (timer < CONSTANTS.bankStatementInterval.MAXTIMER) {
        try {
          timer += CONSTANTS.bankStatementInterval.INTERVALTIMER;
          const reqData = {
            aid: location.state.AppId,
            panNumber: "",
            trackingId: data?.trackingId,
            referenceId: data?.referenceId,
          };

          let resp = await apis.postApi(
            configData.API_URL + "BRE/CheckConsentstatus",
            reqData
          );

          let result = await resp?.json();
          if (resp?.status === 200) {
            let responseData = result?.data;
            if (
              CHECKCONSENTSTATUS[2] === responseData?.status &&
              responseData?.isDataAvailable
            ) {
              setLoading(false);
              //success
              timer = CONSTANTS.bankStatementInterval.MAXTIMER;
              clearApiCheck();
              checkMobileStHandler(data);
            }
            loggerStore(
              location?.state?.AppId,
              `Dual ConsentLink status completed on Bank statement Page = ${JSON?.stringify(
                result
              )}`,
              "Success"
            );
          }
        } catch (error) {
          // setLoading(false);
          const errorResult = JSON.parse(error?.message);
          let responseErrData = errorResult?.statusMessage;
          if (!CHECKCONSENTSTATUS.includes(responseErrData)) {
            //error
            window.scrollBy(0, window.innerHeight);
            timer = CONSTANTS.bankStatementInterval.MAXTIMER;
            clearApiCheck();
            setDisabled(true);
            setLoading(false);
            setBankName([]);
            const ele = bankNameRef?.current?.getElementsByClassName(
              "MuiAutocomplete-clearIndicator"
            )[0];
            if (ele) ele?.click();
            // setPhoneNum("");
            setFormData(initialdata);
            setRadioVal(BANKSTATEMENTUPLOAD);
            setInputFileDisable(false);
            setInputMnoDisable(true);
            // window.scrollTo({ top: 500, behavior: "smooth" });
            loggerStore(
              location?.state?.AppId,
              `Dual ConsentLink pending on Bank statement Page = ${JSON?.stringify(
                errorResult
              )}`,
              "error"
            );
          }
        }
      } else if (timer >= CONSTANTS.bankStatementInterval.MAXTIMER) {
        //timeout
        window.scrollBy(0, window.innerHeight);
        // window.scrollTo({ top: 500, behavior: "smooth" });
        clearApiCheck();
        setDisabled(true);
        setLoading(false);
        setBankName([]);
        const ele = bankNameRef?.current?.getElementsByClassName(
          "MuiAutocomplete-clearIndicator"
        )[0];
        if (ele) ele?.click();
        // setPhoneNum("");
        setFormData(initialdata);
        setRadioVal(BANKSTATEMENTUPLOAD);
        setInputFileDisable(false);
        setInputMnoDisable(true);
      }

      function clearApiCheck() {
        clearInterval(apiCheck);
      }
    }, CONSTANTS.bankStatementInterval.INTERVALTIMER);
  };

  let handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const handleDualAPIBankDetail = async () => {
        try {
          const reqData = {
            applicationid: location?.state?.AppId,
            panNumber: "",
            phoneNumber: formData?.phoneNumber,
            trackingId: location?.state?.AppId,
            templateType: [],
            fipIds: bankName || [],
          };
          const resp = await apis.postApi(
            configData.API_URL + "BRE/CreateDualConsentLink",
            reqData
          );
          let result = await resp.json();
          if (
            resp?.status === 200 &&
            "redirectionUrl" in result?.data &&
            result?.data?.redirectionUrl
          ) {
            const checkBlocker = window.open(
              result?.data?.redirectionUrl,
              "_blank"
            );
            if (
              !checkBlocker ||
              checkBlocker.closed ||
              typeof checkBlocker.closed === "undefined"
            ) {
              setFinalErr(
                "Your browser popup is blocked please refresh the page and try again"
              );
            }
            handleSetInterval(result?.data?._templResp?.[0]);
            loggerStore(
              location?.state?.AppId,
              `Dual ConsentLink created successfully on Bank statement Page = ${JSON?.stringify(
                result
              )}`,
              "Success"
            );
          }
        } catch (error) {
          const errorResult = JSON.parse(error?.message);
          setFinalErr(
            errorResult?.statusMessage ||
              "Facing issue while processing request, please try again after sometime."
          );
          setLoading(false);
          loggerStore(
            location?.state?.AppId,
            `Dual ConsentLink created Failed on Bank statement Page = ${JSON?.stringify(
              errorResult
            )}`,
            "error"
          );
        }
      };

      const handleDocUploadStatusSetInIerval = () => {
        let timer = 0;
        setRetryDocUploadStatus(false);
        const apiCheck = setInterval(async () => {
          if (timer < CONSTANTS.bankStatementInterval.MAXTIMER) {
            try {
              timer += CONSTANTS.bankStatementInterval.INTERVALTIMER;
              const reqData = {
                aid: location.state.AppId,
              };
              const resp = await apis.postApi(
                configData.API_URL + "BRE/DocumentUploadStatus",
                reqData
              );
              let result = await resp.json();

              if (resp?.status === 200) {
                timer = CONSTANTS.bankStatementInterval.MAXTIMER;
                clearApiCheck();
                setLoading(false);
                navigate("/loading", {
                  state: { AppId: location.state.AppId },
                });
                loggerStore(
                  location?.state?.AppId,
                  `Documents upload status completed on Bank statement Page = ${JSON?.stringify(
                    result
                  )}`,
                  "Success"
                );
              }
            } catch (error) {
              const errorResult = JSON.parse(error?.message);
              // setLoading(false);
              if (!CHECKBSTRSP.includes(errorResult?.statusMessage)) {
                timer = CONSTANTS.bankStatementInterval.MAXTIMER;
                clearApiCheck();
                setLoading(false);
                setInputMnoDisable(true);
                // setInputFileDisable(true);
                setFinalErr(errorResult?.statusMessage);
                // setDocUploadEMsg(errorMessage[1]);
                window.scrollTo({ top: 2500, behavior: "smooth" });
                loggerStore(
                  location?.state?.AppId,
                  `Documents upload status in pending status on Bank statement Page = ${JSON?.stringify(
                    errorResult
                  )}`,
                  "error"
                );
              }
            }
          } else if (timer >= CONSTANTS.bankStatementInterval.MAXTIMER) {
            clearApiCheck();
            setLoading(false);
            setInputMnoDisable(true);
            setInputFileDisable(true);
            setRetryDocUploadStatus(true);
            window.scrollTo({ top: 1500, behavior: "smooth" });
          }
        }, CONSTANTS.bankStatementInterval.INTERVALTIMER);

        function clearApiCheck() {
          // console.log("chealr Interval called");
          clearInterval(apiCheck);
        }
      };

      const handleAPIBankStatement = async () => {
        if (retryDocUploadStatus) {
          handleDocUploadStatusSetInIerval();
        } else {
          try {
            const reqData = {
              FileDetails: (() => {
                let data;
                for (const key of Object.keys(files)) data = files[key];
                return data;
              })(),
              aid: location.state.AppId,
              pdfFilepasswords: formData?.pdfPassword,
              zipFilePassword: formData?.zipPassword,
            };
            let resp = await apis.postWithFilesApi(
              configData.API_URL +
                "BRE/" +
                (!zipExtensionHide ? "UploadFIUZipBankSt" : "UploadFIUBankSt"),
              reqData
            );
            let result = await resp?.json();
            if (resp?.status === 200) {
              handleDocUploadStatusSetInIerval();
            }
          } catch (error) {
            const errorResult = JSON.parse(error?.message);
            setLoading(false);
            setInputMnoDisable(true);
            setFinalErr(errorResult?.statusMessage);
            window.scrollTo({ top: 2500, behavior: "smooth" });
          }
        }
      };

      // if we get false from POSTAPI then we change the scrollTop value and change the inputFileDisable as false here

      if (radioVal === BANKSELECT) {
        // handleSingleAPIBankDetail();  //for single consent link
        handleDualAPIBankDetail(); //for dual consent link
      } else {
        handleAPIBankStatement(); // for bank statement upload
      }
      // setLoading(false);
    } catch (err) {
      setLoading(false);
      //console.log(err);
    }
  };

  const getFileExtensionName = (e) => {
    let fileName = e.target.files[0].name;
    let dotPosition = fileName.lastIndexOf(".");
    return fileName.substring(dotPosition + 1).toLowerCase();
  };
  const savefile = (e) => {
    // console.log("check file name-----", e.target.files);
    // console.log("check file name-----",);
    setBankStmtEmsg("");
    setFormData(initialdata);
    setDocUploadEMsg("");
    if (e.target.files?.length > 0) {
      setFiles(e.target.files);
      if (getFileExtensionName(e) === "pdf") {
        setPdfExtensionHide(false);
        setZipExtensionHide(true);
      }
      if (getFileExtensionName(e) === "zip") {
        setPdfExtensionHide(false);
        setZipExtensionHide(false);
      }
      setDisabled(false);
    } else {
      setFiles(undefined);
      setPdfExtensionHide(true);
      setZipExtensionHide(true);
      setDisabled(true);
    }
  };
  let accountProviderList = async () => {
    try {
      setLoading(true);
      let resp = await apis.getApi(
        configData.API_URL + "BRE/GetAccountProvidersList"
      );

      let result = await resp?.json();
      if (resp?.status === 200) {
        setLoading(false);
        setBankNameList(result?.data);
      }
    } catch (error) {
      const errorResult = JSON.parse(error?.message);
      setFinalErr(errorResult?.statusMessage);
      setLoading(false);
    }
  };
  useEffect(() => {
    accountProviderList();
  }, []);

  const handleRadioButton = (e) => {
    setRetryDocUploadStatus(false);
    setDisabled(true);
    let radioValue = e.target.value;
    setRadioVal(radioValue);
    if (radioValue === BANKSELECT) {
      setInputMnoDisable(false);
      setInputFileDisable(true);
    } else {
      setInputMnoDisable(true);
      setInputFileDisable(false);
    }
  };

  const handleClosedFunk = () => {
    setFinalErr("");
  };

  return (
    <>
      <Container
        maxWidth={false}
        className={`${styles.bankstatementBox} container_Th`}
      >
        <Header showBar={true} step={8} />
        <form onSubmit={handleSubmit}>
          <Box>
            <IntroCard title="Bank Details" img="/assets/doc.svg" />

            <RadioGroup name="" value={radioVal} onChange={handleRadioButton}>
              <Radio
                disable={retryDocUploadStatus}
                align="flex-center"
                value={BANKSELECT}
                label="Please enter mobile number and select the bank name"
                component={
                  <>
                    <Input
                      type="tel"
                      name="phoneNumber"
                      value={formData?.phoneNumber}
                      autoComplete="off"
                      disabled={inputMnoDisable}
                      custStyle={{ border: "10px !important" }}
                      label="Mobile number"
                      // onChange_Old={(e) => {
                      //   setPhoneNum(e.target.value);
                      //   // if (e.target.value !== "" && bankName !== undefined) {
                      //   if (e.target.value !== "" && bankName?.length > 0) {
                      //     setDisabled(false);
                      //   } else {
                      //     setDisabled(true);
                      //   }
                      //   if (
                      //     isNaN(e.target.value) ||
                      //     (e.target.value.length > 10 &&
                      //       e.target.value.length !== 10)
                      //   ) {
                      //     setEMsg(errors[1]);
                      //     setIsError(true);
                      //   } else {
                      //     setIsError(false);
                      //   }
                      // }}
                      onChange={handleOnChange}
                    />
                    {mobileErr && (
                      <Box mt={-4} ml={1}>
                        <Typography
                          variant="p"
                          color="subtitle"
                          className="errorMsg_Th"
                        >
                          {mobileErr}
                        </Typography>
                      </Box>
                    )}

                    <Autocomplete
                      size="small"
                      className="inputbg_Th"
                      key={"bankNameKey"}
                      ref={bankNameRef}
                      multiple
                      autoComplete
                      onChange={(e, n) => {
                        setBankStmtEmsg("");
                        // console.log("first----", n);
                        let arr = [];
                        let data = n.map((val) => {
                          arr.push(val.id);
                        });

                        setBankName(arr);
                        // if (n?.id !== undefined && phoneNum !== "") {
                        if (arr?.length === 1) {
                          arr[0]?.id === "-1" &&
                            setBankStmtEmsg(
                              "There is an issue while fetching bank name, please upload bank statement below"
                            );
                          setDisabled(true);
                        }
                        if (n?.length > 0) {
                          if (arr?.length === 1 && arr[0]?.id === "-1") {
                            // arr[0]?.id === "-1" && setDisabled(true);
                            setDisabled(true);
                          } else {
                            setDisabled(false);
                          }
                        } else {
                          setDisabled(true);
                        }
                      }}
                      id="Bank_data"
                      getOptionLabel={(bankNameList) => `${bankNameList.name}`}
                      options={bankNameList}
                      isOptionEqualToValue={(option, value) =>
                        option.name === value.name
                      }
                      disableCloseOnSelect
                      disabled={
                        inputMnoDisable || !formData?.phoneNumber || mobileErr
                      }
                      // renderOption={(props, bankNameList) => (
                      //   <Box componanmt="li" {...props} key={bankNameList.name}>
                      //     {bankNameList.name}
                      //   </Box>
                      // )}
                      renderOption={(props, bankNameList, { selected }) => (
                        <li
                          className="typo_Th"
                          {...props}
                          key={bankNameList?.id}
                        >
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {bankNameList.name}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField {...params} label="Select Bank" />
                      )}
                    />
                    {bankStmtEmsg && (
                      <p style={{ color: "red" }}>{bankStmtEmsg}</p>
                    )}
                    <Note note="If Bank Name is missing from the drop down, please upload bank statement below" />
                  </>
                }
              />
              <Radio
                align="flex-center"
                disable={retryDocUploadStatus}
                value={BANKSTATEMENTUPLOAD}
                label="Please upload the bank statement of last six months."
                component={
                  <>
                    <Input
                      type="file"
                      multiple
                      onChange={savefile}
                      disabled={inputFileDisable}
                      name="bankSt"
                      id="bankStId"
                      accept=".zip,application/pdf"
                    />

                    <Note note="Only files with .pdf or .zip extension allowed,If any of the bank statements is password protected, please enter the password below" />
                    <Input
                      type="password"
                      name="zipPassword"
                      autoComplete="off"
                      value={formData?.zipPassword}
                      sx={{ display: !zipExtensionHide ? "block" : "none" }}
                      disabled={inputFileDisable}
                      label="Zip Password"
                      // onChange={(e) => {
                      //   setZipPass(e.target.value);
                      // }}
                      onChange={handleOnChange}
                    />
                    <Box sx={{ mt: "32px" }}>
                      <Input
                        // type="password"
                        type={zipExtensionHide ? "password" : "text"}
                        name="pdfPassword"
                        autoComplete="off"
                        value={formData?.pdfPassword}
                        sx={{ display: !pdfExtensionHide ? "block" : "none" }}
                        disabled={inputFileDisable}
                        label="Pdf Password"
                        // onChange={(e) => {
                        //   setPdfPass(e.target.value);
                        // }}
                        onChange={handleOnChange}
                      />
                      <Note
                        noteStyle={{
                          display: !zipExtensionHide ? "block" : "none",
                        }}
                        note="Seprate pdfs password using (,)"
                      />
                    </Box>
                  </>
                }
              />
            </RadioGroup>
            {loading && (
              <Backdrop ax="center">
                <LoadingDots screen="bankStatement" />
              </Backdrop>
            )}
            {finalErr && (
              <Backdrop ax="center">
                <AlertPopup
                  finalErr={finalErr}
                  handleClosed={handleClosedFunk}
                />
                ;
              </Backdrop>
            )}
          </Box>

          {docUploadEMsg && <p style={{ color: "red" }}>{docUploadEMsg}</p>}

          {retryDocUploadStatus && (
            <p style={{ color: "red" }}>
              Server seems to be slow, please click on Retry button
            </p>
          )}
          <SubmitButton
            hasNote="No"
            displayVal={retryDocUploadStatus ? "Retry" : ""}
            disabled={disabled}
          />
        </form>
        <Box mb={20}></Box>
      </Container>
    </>
  );
}
